import { render, staticRenderFns } from "./SuperuserTools.vue?vue&type=template&id=776712e3&lang=pug&"
import script from "./SuperuserTools.vue?vue&type=script&lang=js&"
export * from "./SuperuserTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports